module.exports = __webpack_public_path__ + "static/media/share-icon.13227f7b.svg";